<div class="search">
  <div class="col-sm h-100">
    <div class="mx-auto mt-3 alert alert-light alert-dismissible fade show" i18n="search|@@immatriculation" role="alert" style="width:26%">
      Veuillez écrire l'immatriculation sans les tirets et espaces.
    </div>
    <div class="row h-100">
      <div class="col-sm-10 mx-auto align-self-center">
        <input #word (keydown)="setNotFound($event)" (keyup.enter)="doSearch(word.value)" class="form-control form-control-lg search-input" style="position:absolute;" type="text" placeholder="Rechercher Immat" autofocus>
      </div>
      <div class="row mx-auto align-self-center" *ngIf="notFound" style="font-size:3.5em;margin-top:10%;">
        <!--<i class="fa fa-search" aria-hidden="true"></i>-->
        <p class="text-secondary" i18n="search|@@noResult">Aucun résulat <p>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/element/search/search.component.html